import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import ClaimsPage from './components/ClaimsPage';
import BlogsPage from './components/BlogsPage';
import reportWebVitals from './reportWebVitals';
import ClaimsAdminPage from './components/ClaimsAdminPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/claims" element={<ClaimsPage />} />
        <Route path="/ClaimsPage" element={<ClaimsPage />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/admin" element={<ClaimsAdminPage/>} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
